import script from "./CompanyDetailView.vue?vue&type=script&lang=js"
export * from "./CompanyDetailView.vue?vue&type=script&lang=js"

import "./CompanyDetailView.vue?vue&type=style&index=0&id=c310fbe2&lang=scss"

const __exports__ = script;

export default __exports__